/**
 * Standalone entry for /js/reveal-print.js (used by pages that init Reveal via /js/config.js).
 */
import { ensureRevealSummaryPrintPdfQuery, injectRevealPrintPdfStyles } from './reveal-print-core';

ensureRevealSummaryPrintPdfQuery();
injectRevealPrintPdfStyles();
